// extracted by mini-css-extract-plugin
module.exports = {"disabled":"VisuallyDisabled_disabled__Nqc1u"};